import React, { useState, useEffect } from "react";
import Image from "next/image";
import Link from "next/link";

import "venobox/dist/venobox.min.css";

import { useDispatch, useSelector } from "react-redux";
import { useAppContext } from "@/context/Context";
import { addToCartAction } from "@/redux/action/CartAction";
import PriceLabel from "@/components/Labels/PriceLabel";

const Viedo = ({ checkMatchCourses }) => {
  const { cartToggle, setCart } = useAppContext();
  const [toggle, setToggle] = useState(false);
  const [hideOnScroll, setHideOnScroll] = useState(false);

  // =====> Start ADD-To-Cart
  const dispatch = useDispatch();
  const { cart } = useSelector((state) => state.CartReducer);

  const [amount, setAmount] = useState(1);

  const addToCartFun = (id, amount, product) => {
    dispatch(addToCartAction(id, amount, product));
    setCart(!cartToggle);
  };

  useEffect(() => {
    dispatch({ type: "COUNT_CART_TOTALS" });
    localStorage.setItem("hiStudy", JSON.stringify(cart));
  }, [cart]);

  // =====> For video PopUp
  useEffect(() => {
    import("venobox/dist/venobox.min.js").then((venobox) => {
      new venobox.default({
        selector: ".popup-video",
      });
    });

    const handleScroll = () => {
      const currentScrollPos = window.pageYOffset;
      const isHide = currentScrollPos > 200;

      setHideOnScroll(isHide);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <>
      <Link
        className={`video-popup-with-text video-popup-wrapper text-center popup-video sidebar-video-hidden mb--15 ${hideOnScroll ? "d-none" : ""
          }`}
        data-vbtype="video"
        href={checkMatchCourses.introVideoUrl}
      >
        <div className="video-content">
          {checkMatchCourses.image.poster && (
            <Image
              className="w-100 rbt-radius"
              src={checkMatchCourses.image.poster}
              width={355}
              height={255}
              alt="Video Images"
            />
          )}
          <div className="position-to-top">
            <span className="rbt-btn rounded-player-2 with-animation">
              <span className="play-icon"></span>
            </span>
          </div>
          <span className="play-view-text d-block color-white">
            <i className="feather-eye"></i> Preview this course
          </span>
        </div>
      </Link>
      <div className="content-item-content">
        <div className="rbt-price-wrapper d-flex flex-wrap align-items-center justify-content-between">
          <PriceLabel post={checkMatchCourses} />
          {/* {checkMatchCourses.price && checkMatchCourses.price > 0 &&
            <div className="rbt-price">
              <span className="current-price">${checkMatchCourses.price}</span>
              <span className="off-price">${checkMatchCourses.offPrice}</span>
            </div>
          }
          {checkMatchCourses.price && checkMatchCourses.price <= 0 &&
            <div className="rbt-price">
              <span className="current-price">FREE</span>
            </div>
          } */}
          {/* <div className="discount-time">
            <span className="rbt-badge color-danger bg-color-danger-opacity">
              <i className="feather-clock"></i> {checkMatchCourses.days} days
              left!
            </span>
          </div> */}
        </div>

        <div className="add-to-card-button mt--15">
          <Link
            className="rbt-btn btn-gradient icon-hover w-100 d-block text-center"
            href={checkMatchCourses.external_url} target="_blank"
          >
            <span className="btn-text">Start Learning</span>
            <span className="btn-icon">
              <i className="feather-arrow-right"></i>
            </span>
          </Link>
        </div>
        {checkMatchCourses.provider && checkMatchCourses.provider.id == "google" &&
          <div className="add-to-card-button mt--15">
            <Link
              className="rbt-btn btn-gradient icon-hover w-100 d-block text-center"
              href="https://www.anrdoezrs.net/click-101154220-15255255" target="_blank"
            >
              <span className="btn-text">Try Google Cloud free</span>
              <span className="btn-icon">
                <i className="feather-arrow-right"></i>
              </span>
            </Link>
            <span>{`New Google Cloud customers from CloudPedia receive $300 plus an additional $50 in free credits to test, deploy, and explore Google Cloud's AI products for 90 days. Get started using the link above.`}</span>
          </div>
        }
        {/* <div className="buy-now-btn mt--15">
          <Link
            className="rbt-btn btn-border icon-hover w-100 d-block text-center"
            href="#"
          >
            <span className="btn-text">Buy Now</span>
            <span className="btn-icon">
              <i className="feather-arrow-right"></i>
            </span>
          </Link>
        </div> */}
        {/* <span className="subtitle">
          <i className="feather-rotate-ccw"></i> 30-Day Money-Back Guarantee
        </span> */}
        <div
          className={`rbt-widget-details has-show-more ${toggle ? "active" : ""
            }`}
        >
          {/* <ul className="has-show-more-inner-content rbt-course-details-list-wrapper">
            {checkMatchCourses &&
              checkMatchCourses.roadmap.map((item, innerIndex) => (
                <li key={innerIndex}>
                  <span>{item.text}</span>
                  <span className="rbt-feature-value rbt-badge-5">
                    {item.desc}
                  </span>
                </li>
              ))}
          </ul> */}
          <div
            className={`rbt-show-more-btn ${toggle ? "active" : ""}`}
            onClick={() => setToggle(!toggle)}
          >
            Show More
          </div>
        </div>

        <div className="social-share-wrapper mt--30 text-center">
          <div className="rbt-post-share d-flex align-items-center justify-content-center">
            <ul className="social-icon social-default transparent-with-border justify-content-center">
              <li>
                <Link href="https://www.facebook.com/">
                  <i className="feather-facebook"></i>
                </Link>
              </li>
              <li>
                <Link href="https://www.twitter.com">
                  <i className="feather-twitter"></i>
                </Link>
              </li>
              <li>
                <Link href="https://www.instagram.com/">
                  <i className="feather-instagram"></i>
                </Link>
              </li>
              <li>
                <Link href="https://www.linkdin.com/">
                  <i className="feather-linkedin"></i>
                </Link>
              </li>
            </ul>
          </div>
          <hr className="mt--20" />
          {/* <div className="contact-with-us text-center">
            <p>For details about the course</p>
            <p className="rbt-badge-2 mt--10 justify-content-center w-100">
              <i className="feather-phone mr--5"></i> Call Us:{" "}
              <Link href="#">
                <strong>+444 555 666 777</strong>
              </Link>
            </p>
          </div> */}
        </div>
      </div>
    </>
  );
};

export default Viedo;
